import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { InstanceAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';

@Injectable()
export class AdminOfInstanceService {
    constructor(private authService: AuthService, private http: Http) { }
    private JQueryHelper: JQueryHelperService = new JQueryHelperService();
    public GetAdminOfInstanceList(instanceHashID: string, input?: DataListModel): Observable<IAPIResponse> {
        let getInstanceAdminUrl = WeGoConfig.API_GET_ADMIN_OF_INSTANCE_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getInstanceAdminUrl = getInstanceAdminUrl + "?" + queryString + "&instanceHashID=" + instanceHashID;
        }
        else {
            getInstanceAdminUrl = getInstanceAdminUrl + "?instanceHashID=" + instanceHashID;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getInstanceAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfInstance(instanceHashID: string, selectedAdminOfCustomerList: string[]): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfInstance = WeGoConfig.API_POST_DELETE_ADMIN_OF_INSTANCE + "?instanceHashId=" + instanceHashID;

        return this.http.post(urlDeleteAdminOfInstance, selectedAdminOfCustomerList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportAdminOfInstanceList(instanceHashID: string, input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let exportToCSVInstanceAdminUrl = WeGoConfig.API_EXPORT_ADMIN_OF_INSTANCE_LIST + "?" + queryString + "&instanceHashID=" + instanceHashID;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(exportToCSVInstanceAdminUrl, options);
    }

    public GetAllRoleAvailability(input?: DataListModel, instanceHashID?: string): Observable<IAPIResponse> {
        let getRoleAvailabilityListUrl = WeGoConfig.API_GET_INSTANCE_ROLEAVAILABILITY_LIST + "?instanceHashID=" + instanceHashID;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getRoleAvailabilityListUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfInstanceRole(instanceHashID: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfInstance = WeGoConfig.API_POST_DELETE_ADMIN_OF_INSTANCE_ROLE + "?instanceHashID=" + instanceHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;

        return this.http.get(urlDeleteAdminOfInstance, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public AddAdminOfInstanceRole(instanceHashID: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlAddAdminOfInstance = WeGoConfig.API_POST_ADD_ADMIN_OF_INSTANCE_ROLE + "?instanceHashID=" + instanceHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;;

        return this.http.get(urlAddAdminOfInstance, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetPersonListToInvite(instanceHashID: string, emailAddress: string): Observable<IAPIResponse> {
        let getComapanyAdminUrl = WeGoConfig.API_GET_INSTANCE_PERSON_TO_INVITE_LIST;

        getComapanyAdminUrl = getComapanyAdminUrl + "?instanceHashID=" + instanceHashID + "&emailAddress=" + emailAddress;

        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getComapanyAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public InviteAdminOfInstance(customerAdminInvitationModel: InstanceAdminInvitationModel): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlInviteAdminOfCustomer = WeGoConfig.API_POST_INVITE_ADMIN_OF_INSTANCE;

        return this.http.post(urlInviteAdminOfCustomer, customerAdminInvitationModel, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-instance/models/admin-of-instance.service.ts